module.exports = __webpack_public_path__ + "static/media/jee-white-logo.682101ca.png";